/* ==========================================================================
   HUSTLESTREET — hs.js
   Vanilla JavaScript, без библиотеки.
   Зарежда се от sections/hs-header.liquid (с defer).

   Съдържа:
   1. Drawer система (mobile menu; по-късно cart drawer и search)
   2. Header състояние при скрол
   3. Reveal анимации при скрол
   4. HS.updateCartCount() за по-късната cart логика
   ========================================================================== */
(function () {
  'use strict';

  // Защита срещу двойно зареждане (напр. при презареждане на секция в редактора)
  if (window.HS && window.HS.__loaded) return;
  window.HS = window.HS || {};
  window.HS.__loaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastTrigger = null;
  var revealObserver = null;

  /* ------------------------------------------------------------------------
     1. DRAWERS
     Отваряне: бутон с data-hs-open="ID_НА_DRAWER"
     Затваряне: елемент с data-hs-close вътре в .hs-drawer
     ------------------------------------------------------------------------ */
  function getFocusable(container) {
    var selector =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.slice
      .call(container.querySelectorAll(selector))
      .filter(function (el) {
        return el.getClientRects().length > 0;
      });
  }

  function setExpanded(id, value) {
    document.querySelectorAll('[data-hs-open="' + id + '"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', value ? 'true' : 'false');
    });
  }

  function openDrawer(panel, trigger) {
    if (!panel) return;

    // Само един drawer е отворен наведнъж
    var opened = document.querySelector('.hs-drawer.is-open');
    if (opened && opened !== panel) closeDrawer(opened, false);

    lastTrigger = trigger || document.activeElement;
    panel.classList.add('is-open');
    document.documentElement.classList.add('hs-no-scroll');
    setExpanded(panel.id, true);

    var target = panel.querySelector('[data-hs-autofocus]') || getFocusable(panel)[0];
    window.setTimeout(function () {
      if (target) target.focus();
    }, 50);
  }

  function closeDrawer(panel, restoreFocus) {
    if (!panel || !panel.classList.contains('is-open')) return;

    panel.classList.remove('is-open');
    document.documentElement.classList.remove('hs-no-scroll');
    setExpanded(panel.id, false);

    if (restoreFocus !== false && lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
  }

  // Event delegation: работи и след презареждане на секции в Theme Editor
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-hs-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-hs-open')), opener);
      return;
    }

    var closer = event.target.closest('[data-hs-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('.hs-drawer'));
    }
  });

  // ESC затваря; Tab остава вътре в отворения drawer (focus trap)
  document.addEventListener('keydown', function (event) {
    var open = document.querySelector('.hs-drawer.is-open');
    if (!open) return;

    if (event.key === 'Escape') {
      closeDrawer(open);
      return;
    }

    if (event.key === 'Tab') {
      var focusable = getFocusable(open);
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  // Ако прозорецът стане desktop ширина, затваряме мобилното меню
  var desktopQuery = window.matchMedia('(min-width: 990px)');
  function onBreakpointChange(event) {
    if (event.matches) closeDrawer(document.getElementById('hs-menu'), false);
  }
  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', onBreakpointChange);
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(onBreakpointChange);
  }

  /* ------------------------------------------------------------------------
     2. HEADER STATE
     .is-scrolled се добавя след малък скрол (нужно за transparent header)
     --hs-header-height се обновява с реалната височина
     ------------------------------------------------------------------------ */
  var scrollTicking = false;

  function updateScrolled() {
    var header = document.querySelector('[data-hs-header]');
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 40);
    scrollTicking = false;
  }

  function updateHeaderHeight() {
    var header = document.querySelector('[data-hs-header]');
    if (header) {
      document.documentElement.style.setProperty('--hs-header-height', header.offsetHeight + 'px');
    }
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!scrollTicking) {
        scrollTicking = true;
        window.requestAnimationFrame(updateScrolled);
      }
    },
    { passive: true }
  );

  window.addEventListener('resize', updateHeaderHeight);

  /* ------------------------------------------------------------------------
     3. REVEAL ON SCROLL (.hs-reveal и .hs-img-reveal)
     ------------------------------------------------------------------------ */
  function initReveal() {
    var items = document.querySelectorAll('.hs-reveal:not(.is-visible), .hs-img-reveal:not(.is-visible)');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
      );
    }

    items.forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  /* ------------------------------------------------------------------------
     4. CART COUNT (ще се вика от cart drawer-а във Фаза 9)
     ------------------------------------------------------------------------ */
  window.HS.updateCartCount = function (count) {
    document.querySelectorAll('[data-hs-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !(count > 0);
    });
  };

  /* ------------------------------------------------------------------------
     INIT
     ------------------------------------------------------------------------ */
  function init() {
    initReveal();
    updateHeaderHeight();
    updateScrolled();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme Editor презарежда секции динамично
  document.addEventListener('shopify:section:load', init);
})();